module.exports = __webpack_public_path__ + "img/1588974517.2773a61b.png";